import React from "react";
import { motion } from "framer-motion";

const variants = {
  initial: { opacity: 0, y: 16 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -16,
    transition: { duration: 0.28, ease: "easeInOut" },
  },
};

const PageTransition = ({ children }) => {
  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{ minHeight: "calc(100vh - 64px)" }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;

